import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface RedoChatThreadViewProps {
  thread: ConversationThread;
}

export const RedoChatThreadView = memo(function RedoChatThreadView({
  thread,
}: RedoChatThreadViewProps) {
  return <ChatThreadView channel="redoChat" thread={thread} />;
});
